module.exports = __webpack_public_path__ + "static/media/inf_57og67.1c39d545.mp3";